// extracted by mini-css-extract-plugin
module.exports = {"container":"CallViewHolder_container__150l1","spin360":"CallViewHolder_spin360__OopQZ"};